const ERROR_MESSAGE_MAP: Record<string, string> = {
  "User already registered": "このメールアドレスは既に登録されています",
  "Invalid login credentials":
    "メールアドレスまたはパスワードが正しくありません",
  "Email not confirmed":
    "メールアドレスが確認されていません。確認メールをご確認ください",
  "Signup requires a valid password":
    "パスワードは6文字以上で入力してください",
  "Unable to validate email address: invalid format":
    "有効なメールアドレスを入力してください",
  "Email rate limit exceeded":
    "しばらく時間をおいてから再度お試しください",
  "email rate limit exceeded":
    "しばらく時間をおいてから再度お試しください",
  "For security purposes, you can only request this once every 60 seconds":
    "セキュリティのため、60秒に1回のみリクエストできます",
  "New password should be different from the old password.":
    "新しいパスワードは現在のパスワードと異なるものにしてください",
};

export function getAuthErrorMessage(error: string): string {
  return (
    ERROR_MESSAGE_MAP[error] ??
    "エラーが発生しました。しばらく時間をおいてから再度お試しください"
  );
}
